import type {
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';

export type PrefixFormGroup = FormGroup<{
  abbreviationName: FormControl<number>;
}>;

export class PrefixValidator {
  static unique(array: FormArray<PrefixFormGroup>): ValidationErrors | null {
    if (!array?.value.length) {
      return null;
    }

    const prefixes = array.value.map((item) => item.abbreviationName);

    if (new Set(prefixes).size !== prefixes.length) {
      return { unique: { valid: false } };
    }

    return null;
  }
}
